import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]

import { ref, shallowRef, watchEffect } from 'vue'
import ModalRecapPreview from '../ModalRecapPreview.vue'
import { Table } from '../../types/components/data-rendering'
import { useMerchPlanner } from '../../store/useMerchPlanner'
import { storeToRefs } from 'pinia'
import { useFilteringDisplayOptions } from '../../composables/useFilteringDisplayOptions'
import FilteringDataDisplay from '../FilteringDataDisplay.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'MerchPlannerIndex',
  setup(__props) {

const loading = ref(true)
const data = shallowRef<Table>({ data: [], meta: { columns: {} } })

watchEffect(
  async () => {
    const { getMerchPlannerData } = storeToRefs(useMerchPlanner())
    data.value = getMerchPlannerData.value
    loading.value = false
  },
  { flush: 'post' }
)

const isFetching = ref(false)
const { merchPlannerDisplayOptions } = useFilteringDisplayOptions({
  isFetching,
})

//Recap preview logic
const recap = ref(false)
const recapId = ref(null)
const previewRecap = (recap_id: any) => {
  recap.value = true
  recapId.value = recap_id
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(FilteringDataDisplay, {
      key: data.value,
      "is-loading": loading.value,
      "table-data": data.value,
      "display-type": _ctx.displayType,
      options: _unref(merchPlannerDisplayOptions)
    }, {
      recap: _withCtx(({ rowData }) => [
        _createElementVNode("span", {
          onClick: ($event: any) => (previewRecap(rowData['recap']))
        }, " Preview Recap ID: " + _toDisplayString(rowData['recap']), 9, _hoisted_1)
      ]),
      _: 1
    }, 8, ["is-loading", "table-data", "display-type", "options"])),
    _createVNode(ModalRecapPreview, {
      modelValue: recap.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((recap).value = $event)),
      "recap-id": recapId.value,
      "recap-type": 'task'
    }, null, 8, ["modelValue", "recap-id"])
  ], 64))
}
}

})